export default "__VITE_ASSET__ZQJBB8y8__"